import { atom } from "jotai";

export const selectedFormNameAtom = atom<
  "volunteering" | "demo-registration" | "event-registration"
>("event-registration");
